// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import registerControllers from '../register_controllers'

registerControllers(import.meta.glob('./**/*_controller.js', { eager: true }))
